import { ComponentProps, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { PageStrings } from '@alltrails/shared/utils/constants/pageStringHelpers';
import useReduxListItems from '@alltrails/lists/hooks/useReduxListItems';
import logTrailDetailsActionTapped from '@alltrails/amplitude/events/logTrailDetailsActionTapped';
import IconButton from '@alltrails/denali/components/IconButton';
import Bookmark from '@alltrails/denali/icons/Bookmark';
import BookmarkFilled from '@alltrails/denali/icons/BookmarkFilled';
import type { Size } from '@alltrails/denali/types';
import logTrailDetailsAddToListButtonTapped from '@alltrails/amplitude/events/logTrailDetailsAddToListButtonTapped';
import TrailDetailsActionLocation from '@alltrails/amplitude/enums/TrailDetailsActionLocation';
import CardLocation from '@alltrails/amplitude/enums/CardLocation';

const reduxListsAnalyticsInfo = { detailedCardLocation: 'trail banner' as CardLocation, page: PageStrings.TRAIL_PAGE };

type SaveCtaProps = {
  buttonLocation?: TrailDetailsActionLocation;
  size?: Size<'sm' | 'md'>;
  trailId: number;
  testId?: string;
  variant?: ComponentProps<typeof IconButton>['variant'];
};

const SaveCta = ({ buttonLocation, trailId, variant, testId, size = 'md' }: SaveCtaProps) => {
  const intl = useIntl();

  const { isFavorite, handleFavoriteClick, listModal, signUpModal } = useReduxListItems(
    undefined,
    false /* preventAutoInitialize */,
    reduxListsAnalyticsInfo
  );

  const onFavoriteClick = useCallback(() => {
    logTrailDetailsActionTapped({ trail_id: trailId.toString(), trail_page_action: 'save', trail_page_location: buttonLocation });
    logTrailDetailsAddToListButtonTapped({ trail_id: trailId });

    handleFavoriteClick('trail', trailId);
  }, [buttonLocation, handleFavoriteClick, trailId]);

  return (
    <>
      <IconButton
        icon={{ Component: isFavorite('trail', trailId) ? BookmarkFilled : Bookmark }}
        onClick={onFavoriteClick}
        size={size}
        testId={testId}
        title={intl.formatMessage({ defaultMessage: 'Save' })}
        variant={variant}
      />
      {listModal}
      {signUpModal}
    </>
  );
};

export default SaveCta;
